<template>
    <component :is="component" v-if="component" :paginationData="paginationData" :competitionData="competitionData" ></component>
</template>

<script>
export default {
    name: "CompetitionListLink",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        listLayout: '',
        competitionData: {
            type: Array,
            default: () => []
        },
        paginationData: {default: {page: 1, size: 10, total: 0}},

    },
    data() {
        return {
            component: null,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.loader()
            .then(() => {
                this.component = () => this.loader()
            })
            .catch(() => {
                this.component = () => import('@/template/competition/list/CompetitionListDefaultLayout')
            })
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        loader() {
            if (!this.listLayout) {
                return null
            }
            return () => import(`@/template/competition/list/${this.listLayout}`)
        },
    },
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
